import { useMounted } from '@vueuse/core';
import type { Ref } from 'vue';
import { watch, toValue, onMounted, isRef } from 'vue';

export default function useDocTitle(title: string | Ref<string>) {
  const isMounted = useMounted();

  const setTitle = (t: string = toValue(title)) => {
    const prefix = import.meta.env.DEV ? '[dev] ' : '';
    document.title = `${prefix}${t} – Ubercourse`;
  };

  onMounted(setTitle);

  if (isRef(title))
    watch(title, t => {
      if (isMounted.value) setTitle(t);
    });
}
